import { render } from "./OptionsInteractionVideo.vue?vue&type=template&id=3c4f12d5"
import script from "./OptionsInteractionVideo.vue?vue&type=script&lang=js"
export * from "./OptionsInteractionVideo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__